import { StateCreator } from 'zustand';
import { IAppStore } from '../../../IAppStore';
import AttributeSearchSlice, {
  AttributeSearchSliceProps,
  SearchProps,
} from './AttributeSearchSlice';

export const defaultAttributeSearchSliceProps: AttributeSearchSliceProps = {
  attributeSearch: {},
  currentAttributeSearchTopicId: null,
};

const createAttributeSearchSlice: StateCreator<
  IAppStore,
  [],
  [],
  AttributeSearchSlice
> = (set, get) => ({
  ...defaultAttributeSearchSliceProps,
  setAttributeSearch: (topicLayer: string, searchProps: SearchProps) => {
    const attributeSearch = { ...get().attributeSearch };
    attributeSearch[topicLayer] = searchProps;
    set({ attributeSearch });
  },
  setCurrentAttributeSearchTopicId: (activeTopicId: string | null) =>
    set({ currentAttributeSearchTopicId: activeTopicId }),
});

export default createAttributeSearchSlice;
